import { useDenominationsGridWebstoreTelescopeContext } from "../context/denominations_grid";

type GcAmountHeaderProps = {
  brandTitle: string;
  brandLogoUrl: string;
  brandColor: string;
  isFreeText: boolean;
};

export function GcAmountHeader(props: GcAmountHeaderProps) {
  const gridState = useDenominationsGridWebstoreTelescopeContext();
  const { internalState } = gridState;
  const { dryRunErrorMessage } = internalState;

  return (
    <div class="relative flex  w-full flex-row items-start justify-between ">
      {/* Gradient overlay at top */}
      <div class="flex flex-col items-start justify-start">
        <span class="text-title-3-semi-bold text-text-normal-primary">
          Gift card value
        </span>
        <span class="text-para-3-regular text-text-normal-secondary">
          Your shopping amount
        </span>
      </div>

      {/* Brand Logo */}
      <div class="relative z-10 flex h-[52px] w-[52px] shrink-0 items-center justify-center overflow-hidden rounded-full border border-[rgba(255,255,255,0.1)] ">
        <img
          src={props.brandLogoUrl}
          alt={props.brandTitle}
          class="h-auto  w-full object-fill"
        />
      </div>
    </div>
  );
}
